export default __webpack_public_path__ + "static/media/35891.9581dc21.jpg";